import {lazy} from "react";

export const CheckGlobalPingForm = lazy(() =>
  import("@/pages/checks/update/sections/globalping/CheckGlobalPingForm.tsx").then((module) => ({
    default: module.CheckGlobalPingForm,
  }))
);
